export const getVariant = <T extends string>(obj: Record<T, boolean>) =>
  Object.keys(obj).find((key) => obj[key as T] === true) as T;
